module.exports = __webpack_public_path__ + "img/mid-setting.5418732b.svg";